import React from "react";
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
// import { HashRouter } from "react-router-dom";

import App from "./components/App.js";

const root = createRoot(document.getElementById("root"));
let urlBase = window.location.pathname.substring(0, window.location.pathname.lastIndexOf("/") + 1);
root.render(
  <React.StrictMode>
    <BrowserRouter
      //  <HashRouter 

      basename={urlBase}
    >

      <App tab="about" rootBase={urlBase} />

      {/* </HashRouter> */}
    </BrowserRouter>
  </React.StrictMode>
)